import { render, staticRenderFns } from "./ModalSimulador.vue?vue&type=template&id=4f95e06e&scoped=true"
import script from "./ModalSimulador.vue?vue&type=script&lang=js"
export * from "./ModalSimulador.vue?vue&type=script&lang=js"
import style0 from "./ModalSimulador.vue?vue&type=style&index=0&id=4f95e06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95e06e",
  null
  
)

export default component.exports